import { useMemo } from 'react';

import { ReportScheduleTypeEnum, StoreReportDataDto } from '@pimm/services/lib/store-inspections';
import { DailyFoodSafetyReport } from '../classes/daily-food-safety-report';
import { CriticalControlPointsReport } from '../classes/critical-control-points-report';
import { CriticalWalkthroughReport } from '../classes/critical-walkthrough-report';
import { StoreFormReport, StoreReportType } from '../classes/store-form-report';
import { ChecklistReport } from '../classes/checklist-report';

// registered class map
const reportMap: Record<string, new (report: StoreReportDataDto) => StoreFormReport> = {
  [StoreReportType.CriticalControlPoints]: CriticalControlPointsReport,
  [StoreReportType.CriticalWalkthrough]: CriticalWalkthroughReport,
  [StoreReportType.DailyFsl]: DailyFoodSafetyReport,
  [StoreReportType.DailyOpsChecklist]: ChecklistReport,
};

export function useGetReportComposer(_report?: StoreReportDataDto) {
  const report = useMemo(() => {
    const { reportType, scheduleType } = _report?.reportData?.reportData ?? {};

    if (!reportType?.name || !_report?.reportData) return undefined;

    let ReportClass = reportMap[reportType.name];

    if (!ReportClass) {
      console.warn(`Unsupported report type: ${reportType.name}`);
      return null;
    }

    if (reportType.name === StoreReportType.CriticalControlPoints && scheduleType === ReportScheduleTypeEnum.Daily) {
      ReportClass = reportMap[StoreReportType.DailyFsl];
    }

    return new ReportClass(_report);
  }, [_report]);

  return report;
}
